import { useMemo } from "react";
import { useTranslation } from "react-i18next";

/**
 * The product name, both for rendering on its own and for interpolating into localizable copy.
 *
 * Brand names are not translated, so the name lives in its own `brands` namespace — kept apart
 * from `common` so it is obvious to a translator that this file is off limits — and sentences
 * that mention the product carry a {{brand}} placeholder rather than the name in full. That keeps
 * the name written out in exactly one place across the whole locale tree.
 *
 * Destructuring covers both uses: `const { brand } = useBrand();` renders directly, and the object
 * itself is the interpolation payload — `t("hero.subtitle", { brand })`.
 */
export const useBrand = (): { brand: string } => {
	const { t } = useTranslation("brands");

	return useMemo(() => ({ brand: t("TreeTier") }), [t]);
};
